/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { useRef, useState, useEffect } from 'react';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';

var mouseEnterTimer = null;
function useTagScroll(props) {
  var tagInputRef = useRef();
  var _props$excessTagsDisp = props.excessTagsDisplayType,
    excessTagsDisplayType = _props$excessTagsDisp === void 0 ? "scroll" : _props$excessTagsDisp,
    readonly = props.readonly,
    disabled = props.disabled;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollDistance = _useState2[0],
    setScrollDistance = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollElement = _useState4[0],
    setScrollElement = _useState4[1];
  var updateScrollElement = function updateScrollElement(element) {
    var scrollElement2 = element.children[0];
    setScrollElement(scrollElement2);
  };
  var updateScrollDistance = function updateScrollDistance() {
    setScrollDistance(scrollElement.scrollWidth - scrollElement.clientWidth);
  };
  var scrollTo = function scrollTo(distance) {
    if (isFunction_1(scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scroll)) {
      scrollElement.scroll({
        left: distance,
        behavior: "smooth"
      });
    }
  };
  var scrollToRight = function scrollToRight() {
    updateScrollDistance();
    scrollTo(scrollDistance);
  };
  var scrollToLeft = function scrollToLeft() {
    scrollTo(0);
  };
  var onWheel = function onWheel(_ref) {
    var e = _ref.e;
    if (readonly || disabled) return;
    if (!scrollElement) return;
    if (e.deltaX > 0) {
      var distance = Math.min(scrollElement.scrollLeft + 120, scrollDistance);
      scrollTo(distance);
    } else {
      var _distance = Math.max(scrollElement.scrollLeft - 120, 0);
      scrollTo(_distance);
    }
  };
  var scrollToRightOnEnter = function scrollToRightOnEnter() {
    if (excessTagsDisplayType !== "scroll") return;
    mouseEnterTimer = setTimeout(function () {
      scrollToRight();
      clearTimeout(mouseEnterTimer);
    }, 100);
  };
  var scrollToLeftOnLeave = function scrollToLeftOnLeave() {
    if (excessTagsDisplayType !== "scroll") return;
    scrollTo(0);
    clearTimeout(mouseEnterTimer);
  };
  var clearScroll = function clearScroll() {
    clearTimeout(mouseEnterTimer);
  };
  var initScroll = function initScroll(element) {
    if (!element) return;
    updateScrollElement(element);
  };
  useEffect(function () {
    initScroll(tagInputRef === null || tagInputRef === void 0 ? void 0 : tagInputRef.current.currentElement);
    return clearScroll;
  }, []);
  return {
    initScroll: initScroll,
    clearScroll: clearScroll,
    tagInputRef: tagInputRef,
    scrollElement: scrollElement,
    scrollDistance: scrollDistance,
    scrollTo: scrollTo,
    scrollToRight: scrollToRight,
    scrollToLeft: scrollToLeft,
    updateScrollElement: updateScrollElement,
    updateScrollDistance: updateScrollDistance,
    onWheel: onWheel,
    scrollToRightOnEnter: scrollToRightOnEnter,
    scrollToLeftOnLeave: scrollToLeftOnLeave
  };
}

export { useTagScroll as default };
//# sourceMappingURL=useTagScroll.js.map
